import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ui-simple-select-field',
  templateUrl: './simple-select-field.component.html',
  styleUrls: ['./simple-select-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleSelectFieldComponent<T> {
  @Input() fieldLabel: string;
  @Input() fieldControl: FormControl<T>;
  @Input() values: T[];
}
